// src/pages/PaymentSuccess.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaCheckCircle } from "react-icons/fa";
import { RxCrossCircled } from "react-icons/rx";


const PaymentCancelContainer = () => {
    const [showModal, setShowModal] = useState(true);
    const navigate = useNavigate();
    const closeModal = () => {
        setShowModal(false);
        navigate('/mypage/reservation');
      };

  return (
      <div className="sunny_container">
        {showModal && (
            <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" style={{padding:'32px 0px'}} onClick={(e) => e.stopPropagation()}>
                <span className="close-button" onClick={closeModal}>✖︎</span>
                <RxCrossCircled className="mordal_done_check" style={{color:'orange'}}/>
                <p className="mordal_done_check_title">お支払いがキャンセルされました</p>
            </div>
            </div>
        )}
      </div>
  );
};

export default PaymentCancelContainer;